import React, { useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }, {
    name: 'Areas',
    href: '#areas'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm" data-id="element-340">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-341">
        <div className="flex justify-between items-center h-20" data-id="element-342">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-343">
            <a href="#" className="flex items-center gap-3" data-id="element-344">
              <img src="https://cdn.magicpatterns.com/uploads/hJguF2FSF4VF7Gq2iQCUa2/Jose_Junk_Removal_Logo_(1).png" alt="Jose's Junk Removal Logo" className="h-14 w-auto" data-id="element-345" />
              <span className="font-oswald text-xl font-bold tracking-wide hidden sm:block text-[#1A1A1A]" data-id="element-346">
                JOSE'S JUNK REMOVAL
              </span>
            </a>
          </div>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8" data-id="element-347">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-700 hover:text-[#C8102E] font-semibold text-sm uppercase tracking-wider transition-colors" data-id="element-348">
                {link.name}
              </a>)}
            <a href="tel:8312407401" className="flex items-center gap-2 bg-[#C8102E] text-white px-6 py-3 rounded font-bold hover:bg-red-800 transition-colors shadow-md" data-id="element-349">
              <Phone size={18} data-id="element-350" />
              <span data-id="element-351">(831) 240-7401</span>
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center" data-id="element-352">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700 hover:text-[#C8102E] focus:outline-none p-2" data-id="element-353">
              {isOpen ? <X size={28} data-id="element-354" /> : <Menu size={28} data-id="element-355" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg absolute w-full" data-id="element-356">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-357">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-4 text-base font-bold text-gray-800 hover:text-[#C8102E] hover:bg-gray-50 border-b border-gray-100 uppercase tracking-wide" data-id="element-358">
                {link.name}
              </a>)}
            <div className="pt-4 px-3" data-id="element-359">
              <a href="tel:8312407401" className="flex items-center justify-center gap-2 w-full bg-[#C8102E] text-white px-6 py-4 rounded font-bold text-lg shadow-md" data-id="element-360">
                <Phone size={20} data-id="element-361" />
                <span data-id="element-362">Call (831) 240-7401</span>
              </a>
            </div>
          </div>
        </div>}
    </nav>;
}